export default __webpack_public_path__ + "static/media/thumb_11.bfdc7d8e.webp";